import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CatalogProductShell from "./CatalogProductShell";
import useOfferProducts from "../../../hooks/useOfferProducts";
import { anyProductHasSelectableVariants } from "../../../layouts/product-recommendation/utils/product-variant-utils";

/** Single-product offer wrapper (loads products + renders CatalogProductShell). */
export default function CatalogProductOffer({
  section,
  popupData,
  popupState,
  setPopupState,
  activeStep,
  handleClose,
  isMobile,
  isPreviewMode,
  onProductsChange,
  layoutProfile = "recommendation",
  hideProductButton = false,
  selectedSubType,
  selectedSubIndex,
  onSubBlockClick,
  productIndex = 0,
  isLoading = false,
  loadingMessage = "Loading products…",
  shellId,
}) {
  const { products } = useOfferProducts({
    section,
    popupData,
    activeStep,
    isPreviewMode,
    isMobile,
    onProductsChange,
  });

  const productData = products?.[productIndex] || null;

  const showVariantPickerRow = useMemo(
    () => anyProductHasSelectableVariants(productData ? [productData] : []),
    [productData]
  );

  if (isLoading) {
    return (
      <div style={{ padding: "16px 0", textAlign: "center" }}>{loadingMessage}</div>
    );
  }

  if (!productData) {
    return null;
  }

  return (
    <CatalogProductShell
      section={section}
      productData={productData}
      productIndex={productIndex}
      popupData={popupData}
      popupState={popupState}
      setPopupState={setPopupState}
      activeStep={activeStep}
      handleClose={handleClose}
      isMobile={isMobile}
      isPreviewMode={isPreviewMode}
      selectedSubType={selectedSubType}
      selectedSubIndex={selectedSubIndex}
      onSubBlockClick={onSubBlockClick}
      showVariantPickerRow={showVariantPickerRow}
      layoutProfile={layoutProfile}
      hideProductButton={hideProductButton}
      shellId={shellId}
    />
  );
}

CatalogProductOffer.propTypes = {
  section: PropTypes.object,
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
  activeStep: PropTypes.number,
  handleClose: PropTypes.func,
  isMobile: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  onProductsChange: PropTypes.func,
  layoutProfile: PropTypes.oneOf(["recommendation", "ai-upsell"]),
  hideProductButton: PropTypes.bool,
  shellId: PropTypes.string,
};
